import { ActionType, createAction } from 'typesafe-actions';

export const appVersionMissmatchAction = createAction('APP_VERSION_MISSMATCH')();

export type AppVersionActionTypes = ActionType<typeof appVersionMissmatchAction>;
